const VulnerabilityGeoDashboard = () => {

  return (
   ''
  )
}

export default VulnerabilityGeoDashboard
